import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Loader from 'components/Loader';
import NotificationBox from 'components/Notification';
import CertWarningBar from 'components/CertWarningBar';
import Preload from './Preload';
import AudioPlayer from './AudioPlayer';
import Navigation from './Navigation';
import Header from './Header';
import CreateNewContactPersonModal from './CreateNewContactPersonModal';
import CreateNewCustomerModal from './CreateNewCustomerModal';
import NotificationPanel from './NotificationPanel';

const Layout = ({ children }) => {
	const {
		notifications,
		showNotificationPanel,
		showCreateNewContactPersonModal,
		showCreateNewCustomerModal,
	} = useSelector(state => state.ui);

	return (
		<div className="main">
			<Suspense
				fallback={(
					<Loader withContainer />
				)}
			>
				<Preload>
					<Navigation />

					<section className="main-block">
						<CertWarningBar />
						<Header />
						{children}
					</section>

					<AudioPlayer />
					<NotificationBox notifications={notifications} />

					{showCreateNewContactPersonModal && (
						<CreateNewContactPersonModal />
					)}

					{showCreateNewCustomerModal && (
						<CreateNewCustomerModal />
					)}

					{showNotificationPanel && (
						<NotificationPanel />
					)}
				</Preload>
			</Suspense>
		</div>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Layout;
